export const phoneNumber = [
  {
    required: true,
    message: "手机号不能为空！",
    trigger: "blur"
  },

  // /^1([38][0-9]|4[579]|5[0-3,5-9]|6[6]|7[0135678]|9[89])\d{8}$/
  {
    required: true,
    message: "请输入正确格式的手机号！",
    trigger: "blur",
    pattern: /^1[3-9]\d{9}$/
  }
];

export const password = [
  {
    required: true,
    message: "密码不能为空！",
    trigger: "blur"
  },
  {
    required: true,
    pattern: /^[A-Za-z0-9]+$/,
    message: "密码仅包含数字、大小写英文字母",
    trigger: "blur"
  },
  {
    required: true,
    pattern: /^.{6,20}$/,
    message: "密码长度必须是 6 到 20 个字符之间",
    trigger: "blur"
  },
  {
    required: true,
    pattern: /^(?=.*[0-9])(?=.*[a-zA-Z])(.{6,20})$/,
    message: "密码必须同时包含数字和英文字母",
    trigger: "blur"
  }
];

export const getCheckPasswordValidator = password => {
  const validator = (rule, value, callback) => {
    if (value === "") {
      callback(new Error("请再次输入密码"));
    } else if (value !== password) {
      callback(new Error("两次输入密码不一致!"));
    } else {
      callback();
    }
  };

  return [
    { validator: validator, trigger: "blur" },
    { required: true, trigger: "blur" }
  ];
};

export const verificationCode = [
  {
    required: true,
    message: "验证码不能为空！",
    trigger: "blur"
  },
  {
    required: true,
    message: "验证码必须是4 ~ 6位的数字组合",
    trigger: "blur",
    pattern: /^\d{4,6}$/
  }
];

export const enterpriseBankAccountValidator = _ => {
  const pattern = /^\d{8,30}$/;

  const validator = (rule, value, callback) => {
    value = value.replace(/\s/g, "");
    if (value === "") {
      callback(new Error("银行账户不能为空！"));
    } else if (!pattern.test(value)) {
      callback(new Error("请输入8 ~ 30 位的对公团队银行账户!"));
    } else {
      callback();
    }
  };

  return [{ validator: validator, trigger: "blur", required: true }];
};

export const cityPickerValidator = [
  {
    type: "object",
    required: true,
    trigger: "blur",
    fields: {
      provinceId: { required: true, message: "请选择一个城市" },
      cityId: { required: true, message: "城市的市(区)不能为空" },
      areaId: { required: true, message: "城市的县(区)不能为空" }
    }
  }
];
